import React from 'react';
import { Input } from '../../ui/input';
import { Search, Grid, List } from 'lucide-react';
import { categoryIcons, CATEGORIES } from './constants';

export const HubFilters = ({
  searchQuery,
  setSearchQuery,
  selectedCategory,
  setSelectedCategory,
  viewMode,
  setViewMode,
}) => (
  <div className="flex flex-wrap items-center gap-4 mb-8">
    {/* Search */}
    <div className="relative flex-1 min-w-[200px] max-w-md">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#888680]" />
      <Input
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        placeholder="Search apps..."
        data-testid="hub-search-input"
        className="pl-10 bg-[#302f2c] border-[#1e3a5f] text-[#7dd3fc] placeholder:text-[#888680]/50 h-11"
      />
    </div>

    {/* Category Filter */}
    <div className="flex items-center gap-2">
      <button
        onClick={() => setSelectedCategory('all')}
        className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
          selectedCategory === 'all'
            ? 'bg-[#7dd3fc] text-[#1a1c1b]'
            : 'bg-[#302f2c] text-[#888680] hover:text-[#7dd3fc]'
        }`}
      >
        All
      </button>
      {CATEGORIES.map((cat) => {
        const IconComponent = categoryIcons[cat];
        return (
          <button
            key={cat}
            onClick={() => setSelectedCategory(cat)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all flex items-center gap-2 ${
              selectedCategory === cat
                ? 'bg-[#7dd3fc] text-[#1a1c1b]'
                : 'bg-[#302f2c] text-[#888680] hover:text-[#7dd3fc]'
            }`}
          >
            <IconComponent size={14} />
            {cat.charAt(0).toUpperCase() + cat.slice(1)}
          </button>
        );
      })}
    </div>

    {/* View Toggle */}
    <div className="flex items-center gap-1 bg-[#302f2c] rounded-full p-1 ml-auto">
      <button
        onClick={() => setViewMode('grid')}
        className={`p-2 rounded-full transition-all ${
          viewMode === 'grid' ? 'bg-[#7dd3fc] text-[#1a1c1b]' : 'text-[#888680]'
        }`}
      >
        <Grid size={18} />
      </button>
      <button
        onClick={() => setViewMode('list')}
        className={`p-2 rounded-full transition-all ${
          viewMode === 'list' ? 'bg-[#7dd3fc] text-[#1a1c1b]' : 'text-[#888680]'
        }`}
      >
        <List size={18} />
      </button>
    </div>
  </div>
);
